<template>
  <div class="row d-flex flex-row h-100">
    <auth-left-container> </auth-left-container>
    <div
      class="right-container bg-extra-light-gray p-4 d-flex flex-column justify-content-center align-items-center text-black"
    >
      <div class="center-form">
        <h5 class="mb-4">
          Further instructions have been sent to your email address.
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLeftContainer from "./AuthLeftContainer.vue";

export default {
  name: "AuthResetCode",
  components: {
    AuthLeftContainer
  },
  data() {
    return {
      code: "",
      error: ""
    };
  },
  methods: {}
};
</script>
<style scoped>
.right-container {
  width: 50%;
}
.center-form {
  padding: 0px 15%;
}
</style>
